import { useContext } from "react";
import { ContactCrmContext } from "../contexts/ContactCrmProvider";

const useContactCrm = () => {
  return useContext(ContactCrmContext);
};

export default useContactCrm;
